import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4qm8pqu56k: FaireBrandEntity = {
  token: "b_4qm8pqu56k",
  type: "brand",
  name: "Wildflowers by Floriette",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ce6116cde0bed50a5e227ba5b487709252c8df0522d0ec6fafe1b4911a42813.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9d13c0cb347ed9b551b19a1d0583618b46ddca110fb1c05e4045b84218195edb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9ce6116cde0bed50a5e227ba5b487709252c8df0522d0ec6fafe1b4911a42813.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9d13c0cb347ed9b551b19a1d0583618b46ddca110fb1c05e4045b84218195edb.png",
  location: "NLD",
  minimumOrderDollars: 220,
  rating: 4.9,
  reviewCount: 286,
  isTopShop: true,
  isInsider: false,
  description:
    "The Wildflowers by Floriette collection is designed and created by us, Mariëtte and Manouk. We love to design trendy and beautiful creations, inspired by nature. Our passion is to create something beautiful, something that puts a smile on your face. Together with our suppliers, we select the best flowers to create our products. Most of the dried flowers are natural and ecologically grown by Dutch growers. The flowers are dried with a unique drying process, which ensures the maintenance of vibrant colors and long-lasting quality.\n\nWith everything we do, from flowers to packaging, we strive to work on a sustainable and socially responsible level. Our Wildflowers tags, for example, are printed on paper made out of agricultural waste.\n\nDisclaimer for Orders Outside the EU\nPlease note that orders shipped outside the European Union may be subject to additional charges, such as VAT, import duties, and customs fees. The percentage and amount of these fees vary by country or region and are determined by local authorities. These costs are collected by the courier and are the customer’s responsibility.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.514Z",
    importedBy: "entity-db-cli",
  },
};
